<form class="form-horizontal">

  <div class="form-group">
    <div class="col-xs-12 base-font">
      You have selected Support. A new window should be open with support ticket form. If you don't see it, please copy<br>
      the URL bellow and paste it in your browser.
    </div>
  </div>

  <div class="form-group">
    <div class="col-xs-12 base-font text-link">
    {{fullLink}}
    </div>
  </div>

  <div class="form-group">
    <div class="col-xs-12">
      <button class="base-font btn btn-primary"
              (click)="copyLinkToClipboard()">
       Copy
      </button>
    </div>
  </div>

</form>
